import React from "react";

interface IconCheckProps {
  width?: string;
  height?: string;
  fill?: string;
}

const IconList: React.FC<IconCheckProps> = ({
  width = "20px",
  height = "20px",
  fill = "#f7f5f5",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-list"
  >
    <path d="M3 12h.01" />
    <path d="M3 18h.01" />
    <path d="M3 6h.01" />
    <path d="M8 12h13" />
    <path d="M8 18h13" />
    <path d="M8 6h13" />
  </svg>
);

export default IconList;
